import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../layouts/Default";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Title } from "../../themes/Default/components/Title";
import { Timeline } from "../../themes/Default/components/Timeline";
import { Line } from "../../themes/Default/components/Timeline/components/Line";
import { Main } from "../../themes/Default/components/Main";
import { Button } from "../../themes/Default/components/TopNavigation/components/Button";
import { notificationsManagement } from "../../hooks/api/NotificationsManagement/NotificationsManagement";
import { employeesManagement } from "../../hooks/api/EmployeesManagement/EmployeesManagement";
import { useUserToken } from "../../hooks/core/UserToken";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slices/User";
import { roles } from "../../services/utils/Roles";

const Notifications = () => {
    const { t } = useTranslation("common");
    const { useNotificationsListMutation, useMarkOneAsReadMutation, useMarkAllAsReadMutation, useTotalUnreadMutation} = notificationsManagement;
    const [notificationList] = useNotificationsListMutation();
    const [markOneAsRead] = useMarkOneAsReadMutation();
    const [markAllAsRead] = useMarkAllAsReadMutation();
    const [totalUnreadList] = useTotalUnreadMutation();
    const [notifications, setNotifications] = useState([]);
    const { getDecoded } = useUserToken()[0];
    const decodedToken = getDecoded();
    const userInfo = useSelector(state=>state.user.user);
    const dispatch = useDispatch();
    const {useViewAvatarMutation} = employeesManagement;
    const[ viewAvatar ] = useViewAvatarMutation();
    const [avatars, setAvatars] = useState({});

    const avatarUrl = (employeeId) => {
        viewAvatar(employeeId).then((result) => {
            if (result?.data?.avatar) {
                setAvatars(prevAvatars => {
                    const updatedAvatars = { ...prevAvatars, [employeeId]: result?.data?.avatar };
                    return updatedAvatars;
                });

            }
        });
    };

    const getInitials = (fullName) => {
        const nameParts = fullName.split(' ');
        let initials = '';
      
        nameParts.forEach(part => {
          initials += part.charAt(0).toUpperCase();
        });
      
        return initials;
    };

    const markAsRead = (notificationId) => {
        markOneAsRead({userId: decodedToken?.id, notificationId}).then((result) => {
            notificationsList();

        });
    };

    const markAll= () => {
        markAllAsRead(decodedToken?.id).then((result) => {
            notificationsList();
        });
        
    };

    const notificationsList = () =>{
        notificationList(decodedToken?.id).then((result) => {
            const notifications = result?.data?.records;
            setNotifications(notifications);
            totalUnreads();

            if (notifications && Array.isArray(notifications)) {
                notifications.forEach(notification => {
                    if(notification.createdById){
                        avatarUrl(notification.createdById);
                    }
                    
                });
            }
        });
    };

    const totalUnreads = () =>{
        totalUnreadList(decodedToken?.id).then((result) => {
            const totalUnread = result?.data?.totalRecords;
            dispatch(setUser({totalUnread}));
        });
    };

    useEffect(() => {
        notificationsList();
    }, []);

    return (
        <DefaultLayout>
            <TopNavigation>
                {!(decodedToken?.roles.includes(roles.PROFESSOR)) && !(decodedToken?.roles.includes(roles.PROFESSOR_COORDINATOR)) && (
                    <>
                        <Button title={t('notifications.markAllAsRead')} icon="fa-regular fa-envelope-open" onClick={markAll}></Button>
                    </>
                )} 
            </TopNavigation>
            <Main>
                <Title badge={userInfo.totalUnread > 0 ? userInfo.totalUnread : null}>{t('notifications.title')}</Title>
                <Timeline>
                    {notifications?.length > 0 &&
                        notifications?.map((notification, index) => {
                            const monthFromBack=new Date(notification.receivedAt).toLocaleString('sr-Latn', { month: 'long' });
                            const month = monthFromBack.charAt(0).toUpperCase() + monthFromBack.slice(1);
                            return (
                                <Line 
                                    month={month}
                                    day={new Date(notification.receivedAt).getDate()} 
                                    createdBy={notification.createdBy}
                                    title={notification.title}
                                    message={notification.message} 
                                    isRead={notification.isRead}
                                    timeAgo={notification.timeAgo}
                                    initials={getInitials(notification.createdBy)}
                                    onClick={() => markAsRead(notification.id)}
                                    avatar={avatars[notification.createdById]}
                                />
                            );
                        })}
                </Timeline>
            </Main>
        </DefaultLayout>
    );
};

export default Notifications;
